<div style="padding: 0px; margin: 0px;   height: 80%;">
  <!-- Navbar Start Here-->
  <!-- <nav class="navbar navbar-expand-lg navbar-light">
    <a class="navbar-brand" href="#">
      <img src="assets/img/fastswifflogo.svg" width="121" class="image1 ml-1 img-fluid" height="32.651"
        alt="FastSwiff Logo">
    </a>
    <ul class="navbar-nav ml-auto d-flex flex-row align-items-center">
      <li class="nav-item">
        <p class="nav-link mt-3 mr-2 paragraph">Don’t have a FastSwiff Account?</p>
      </li>
      <li class="nav-item">
        <app-custom-button text="Sign Up" [backgroundColor]="'#09BCE1'" [textColor]="'#fff'" class="mt-2 "
          width="'50%'" (onClick)="OnBoardRedirect()"></app-custom-button>
      </li>
    </ul>
  </nav>  -->
  <!-- Navbar End Here -->

  <div class="" style="height: 100%; ">
    <div style="display: flex;
    flex-wrap: wrap; height:100%">
      <div class="col-md-6 order-md-1 order-sm-2 ">
        <!-- <img class="salyLogo" src="assets/img/Salylgn.png" alt="Top Right Image"> -->

        <!-- Login -->
        <div class="card-body ">
          <div class="text-center">
            <img src="assets/img/fastswifflogo.svg" alt="" height="100%" width="40%"><br><br>
            <h2 class="ml-2" style="color: var( --grey1); font-size: 32px; font-weight: 600;">Namaste! </h2>
            <h5 class="card-title ml-2">
              Stay on top of your finances with ease and speed.
            </h5>
          </div>
          <form style="margin-top: 20px;" #loginform="ngForm" (ngSubmit)="checkUserNameverfication()">
            <div class="form-group ">
              <mat-form-field appearance="outline" class="col-12">
                <mat-label style="color: var(--grey3);">Email ID / Mobile Number</mat-label>
                <input matInput placeholder="" type="text" id="email" name="email" [formControl]="email" required>
              </mat-form-field>
              <span class="text-danger" *ngIf="email.invalid && (email.dirty || email.touched)">{{emailerrors()}}
              </span>
              <small style="color:red;" *ngIf="usernameerror">UserName is Invalid</small>
            </div>
            <div class="form-group" style="margin-top: 30px;">
              <mat-form-field appearance="outline" class="col-12" style="display:block">
                <mat-label style="color: var(--grey3);">Password</mat-label>
                <img matSuffix src="assets/img/dashboard_icons/view.svg" class="view_icon" style="    vertical-align: super;
                border-style: none;" (click)=" showHidePassword()" *ngIf="isView" />
                <img matSuffix src="assets/img/dashboard_icons/no_view.svg" style="vertical-align: super;
                border-style: none;" (click)=" showHidePassword()" class="view_icon" *ngIf="isNoView" />
                <input matInput placeholder="" type="password" id="password" name="password" aria-label="password" input
                  [type]=" showPassword ? 'text' : 'password' " [formControl]="password" required>

              </mat-form-field>

            </div>

            <div class="form-group" style="margin: 15px;">
              <label style="    font-weight: 500;
              margin: 3px;
              color: var(--grey3);
              opacity: 1;
              font-size: 17px;" class="label-text p-0 mb-1">Enter Captcha </label>
              <div style="display: flex;">

                <div class="form-group  col-6 pl-0 ml-0">
                  <div class="captha_div" style="display: flex;">
                    <img [src]="codeImageSrc" alt="Captca" style="height: 50px;">

                    <span class="input-group-addon text-primary" (click)="CaptchaCreation()"
                      style="border-bottom-right-radius: 7px; border-top-right-radius: 7px; font-size: 22px; font-weight: normal;    width: 15%;padding-top: 12px;">
                      <em class="fas fa-sync"></em>
                    </span>
                  </div>
                </div>

                <div class="form-group mb-0 ml-3 col-12">
                  <!-- <label class="customlabel"> Captcha Id*</label> -->
                  <input class="formcontrol-user11 form-control input_icon"
                    style="padding: 12px; width: 45%; border-radius: 10px;" type="text" placeholder="Enter Captcha*"
                    id="Captchacode" maxlength="5" minlength="1" name="Captchacode" aria-label="Captchacode  "
                    [formControl]="Captchacode" (keyup)="Captchacodevalidation()" [(ngModel)]="editcaptcha"
                    onpaste="return false" required>
                  <span style="color:red;" *ngIf="capthaisrequired"></span>
                  <span class="mt-2" style="color:red;" *ngIf="errorcaptha">{{captchaError}}</span>
                </div>

              </div>
            </div>


            <p class="d-flex justify-content-end mt-4 mr-4"><a style="color: var(--main1);cursor: pointer;"
                [routerLink]="['/registration/newpasswordverififcation']">Forgot Password?</a></p>
            <small style="color:red;" *ngIf="ipaddressrequired">Please allow ip address to login</small>
            <small style="color:red;" *ngIf="unauth">Unauthorized User</small>
            <small style="color:red;" *ngIf="isloginfailed">UserName or Password is Invalid</small>
            <small style="color:red;" *ngIf="AccountBlocked">Your Account Is Blocked Please try to Login After 24
              Hours</small>

            <small style="color:red;" *ngIf="isPasswordExpired">password expired</small>
            <small style="color:red;" *ngIf="!isValidMerchant">Merchant Id was not found with given details</small>
            <small style="color:red;" *ngIf="isMerchantNotActive">Merchant Id is not an Active</small>

            <small style="color:red;" *ngIf="isAccountRejected">Your Account was Rejected</small>
            <small style="color:red;" *ngIf="isAccountVerificationPending">Verification pending for your
              Account</small>
            <small style="color:red;" *ngIf="isAccountOnHold">Sorry!, You can not login now due to your account was
              OnHold</small>
            <small style="color:red;" *ngIf="isAccountCancled">Sorry!, You can not login due to your account was
              Cancelled</small>
            <small style="color:red;" *ngIf="isAccountDeclined">Sorry!, You can not login due to your account was
              Declined</small>
            <small style="color:red;" *ngIf="isEmailConfirmationPending">Email Confirmation is pending, please check
              your Email to continue with us. </small>
            <small style="color:red;" *ngIf="isIpAddressVerified">{{ipAddressValidationMsg}} </small>
            <!-- <button matRipple type="submit" 
               [disabled]="password.invalid ||email.invalid ||usernameerror"
    style="outline: none; border: none; padding-inline: 18px; border-radius: 7px; display: flex; align-items: center; justify-content: center;"
     [style.color]="'var(--white)'"
    [style.background-color]="'var(--main1)'" >
    Log in
</button> -->
            <div style="padding: 15px;">
              <button type="submit" class="btn login_button text-center aba col-12"
                [disabled]="password.invalid ||email.invalid ||usernameerror || captchaError">Log in</button>
            </div>
            <div class="text-center" style="text-align: center;">Don't have an account? <a
                style="color: var(--main1);cursor: pointer;" [routerLink]="['/registration/NewSignup']">
                <b> Register For Free</b></a>
            </div>
          </form>

          <!-- <div class="logginBtn ml-2">
            <app-custom-button text="Login" class="login-button-group " width="100%" [backgroundColor]="'#09BCE1'"
              [textColor]="'#fff'" [disabled]="password.invalid ||email.invalid ||usernameerror"></app-custom-button>
          </div> -->
        </div>
      </div>
      <div class="col-md-6 order-md-2 order-sm-1 loginimage" style="background-image: url('assets/img/loginimg1.jpg'); height: 145%; padding: 0px; margin: 0px;
      background-position: center; 
      background-repeat: no-repeat;
      background-size: cover;">
        <div #captchaContainer style="width: 30%;"></div>
      </div>
    </div>
  </div>
</div>